import React from "react";
import { Box, Card } from "@mui/material";
import { makeStyles } from "@mui/styles";
import BackdropScreen from "bundles/common/components/BackdropScreen";
import CompanyBox from "bundles/Recruiter/components/DashboardV2/DashboardContent/CompanyBox";
import CreditsBox from "bundles/Recruiter/components/DashboardV2/DashboardContent/CreditsBox";
import StatsTab from "bundles/Recruiter/components/DashboardV2/DashboardContent/StatsTab";
import MyCandidatesStats from "bundles/Recruiter/components/DashboardV2/DashboardContent/MyCandidatesStats";
import MyJobOffersStats from "bundles/Recruiter/components/DashboardV2/DashboardContent/MyJobOffersStats";
import SuggestedCandidates from "bundles/Recruiter/components/DashboardV2/DashboardContent/SuggestedCandidates";
import useMediaQuery from "@mui/material/useMediaQuery";
import DashboardMetrics from "bundles/Recruiter/components/DashboardV2/DashboardContent/DashboardMetrics";

const DashboardContent = ({ selectedStatsTab, setSelectedStatsTab, kanban, kanbanSummary, jobStatus, candidates, loading, metricsData, metricsLoading, period, setPeriod }) => {
  const isDesktop = useMediaQuery((theme) => theme.breakpoints.up("md"));
  const isLarge = useMediaQuery((theme) => theme.breakpoints.up("lg"));
  const useStyles = makeStyles(() => ({
    companyCardContainer: {
      display: "flex",
      flexDirection: isDesktop ? "row" : "column",
      alignItems: "stretch",
      gap: "20px",
      width: "100%",
    },
  }));

  const classes = useStyles();

  return(
    <Box sx={{my: { xs: "20px", md: "60px"}}}>
      <BackdropScreen open={loading} />
      <Box className={classes.companyCardContainer}>
        <CompanyBox  />

        <CreditsBox />
      </Box>

      <Card sx={{mt: "20px", padding: "20px", borderRadius: "10px", boxShadow: "none"}}>
        <Box>
          <StatsTab
            selectedStatsTab={selectedStatsTab}
            setSelectedStatsTab={setSelectedStatsTab}
            period={period}
            setPeriod={setPeriod}
          />
        </Box>

        <Box sx={{mt: "20px", alignItems: "stretch", display: "flex"}}>
          {selectedStatsTab === 0 &&
            <>
              <Box sx={{ width: "100%", display: "grid", gap: 2, alignItems: "stretch", gridTemplateColumns: isLarge ? "800px 1fr" : "1fr" }}>
                <Box sx={{ display: "flex", flexDirection: "column", minWidth: 0 }}>
                  <Box sx={{ flexGrow: 1, minHeight: "100%", width: "100%", display: "flex", flexDirection: "column", minWidth: 0 }}>
                    <MyCandidatesStats kanban={kanban} kanbanSummary={kanbanSummary} />
                  </Box>
                </Box>
                <Box sx={{ display: "flex", flexDirection: "column", minWidth: 0 }}>
                  <Box sx={{ flexGrow: 1, minHeight: "100%", width: "100%", display: "flex", flexDirection: "column", minWidth: 0 }}>
                    <MyJobOffersStats jobStatus={jobStatus} />
                  </Box>
                </Box>
              </Box>
            </>
          }
          {selectedStatsTab === 1 && <DashboardMetrics metricsData={metricsData} loading={metricsLoading} />}
        </Box>
      </Card>

      <SuggestedCandidates candidates={candidates} loading={loading} />
    </Box>
  );
};

export default DashboardContent;
